var _path, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 29,
    viewBox: "0 0 35 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_190_1387",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8394 3.95058C33.5572 4.51815 32.1813 4.90307 30.7357 5.07492C32.2117 4.19197 33.3416 2.7915 33.8771 1.12786C32.4926 1.94552 30.9642 2.53925 29.3358 2.86111C28.0317 1.4715 26.1769 0.605957 24.1195 0.605957C20.1725 0.605957 16.9722 3.80273 16.9722 7.74325C16.9722 8.30212 17.0354 8.84796 17.1573 9.36993C11.2183 9.07195 5.95203 6.22967 2.42738 1.91072C1.81126 2.96329 1.46075 4.18976 1.46075 5.49896C1.46075 7.97594 2.72346 10.1615 4.63929 11.4402C3.46801 11.401 2.36641 11.0792 1.40201 10.5442V10.6334C1.40201 14.0911 3.86644 16.9769 7.13419 17.6337C6.53548 17.7946 5.90416 17.8837 5.25103 17.8837C4.78952 17.8837 4.34321 17.8381 3.90561 17.7511C4.81559 20.589 7.45423 22.6528 10.5805 22.7094C8.13565 24.6231 5.05292 25.7605 1.70463 25.7605C1.12773 25.7605 0.559482 25.7257 0 25.6626C3.16328 27.6916 6.91872 28.8746 10.955 28.8746C24.1022 28.8746 31.2887 17.9969 31.2887 8.56313L31.2648 7.6389C32.6689 6.63848 33.8837 5.38153 34.8394 3.95058Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_190_1387)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8394 3.95058C33.5572 4.51815 32.1813 4.90307 30.7357 5.07492C32.2117 4.19197 33.3416 2.7915 33.8771 1.12786C32.4926 1.94552 30.9642 2.53925 29.3358 2.86111C28.0317 1.4715 26.1769 0.605957 24.1195 0.605957C20.1725 0.605957 16.9722 3.80273 16.9722 7.74325C16.9722 8.30212 17.0354 8.84796 17.1573 9.36993C11.2183 9.07195 5.95203 6.22967 2.42738 1.91072C1.81126 2.96329 1.46075 4.18976 1.46075 5.49896C1.46075 7.97594 2.72346 10.1615 4.63929 11.4402C3.46801 11.401 2.36641 11.0792 1.40201 10.5442V10.6334C1.40201 14.0911 3.86644 16.9769 7.13419 17.6337C6.53548 17.7946 5.90416 17.8837 5.25103 17.8837C4.78952 17.8837 4.34321 17.8381 3.90561 17.7511C4.81559 20.589 7.45423 22.6528 10.5805 22.7094C8.13565 24.6231 5.05292 25.7605 1.70463 25.7605C1.12773 25.7605 0.559482 25.7257 0 25.6626C3.16328 27.6916 6.91872 28.8746 10.955 28.8746C24.1022 28.8746 31.2887 17.9969 31.2887 8.56313L31.2648 7.6389C32.6689 6.63848 33.8837 5.38153 34.8394 3.95058Z",
    fill: "black"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.263d539757605b3af643b391873263e4.svg";
export { ForwardRef as ReactComponent };